import { AxiosResponse } from 'axios'
import { RequestREAD, RequestCDU } from 'services/Instances'

export const EfetivoLogicoServices = () => {
  const path = 'EfetivoLogico'

  const getPesquisaContratos = async (
    requestObj: ReqGetAllContracts
  ): Promise<AxiosResponse<ResGetAllContracts[]>> =>
    await RequestREAD.post(`${path}/GetContratosEfetivoLogico`, requestObj)

  const getEfetivosporContrato = async (
    requestObj: ReqEffectiveByContract
  ): Promise<AxiosResponse<ResEffectiveByContract>> =>
    await RequestREAD.post(`${path}/GetByContract`, requestObj)

  const getEfetivoLogicoById = async (
    idEfetivoLogico: number
  ): Promise<AxiosResponse<EffectiveData>> =>
    await RequestREAD.get(
      `${path}/GetEfetivoLogicoById?idEfetivoLogico=${idEfetivoLogico}`
    )

  const getEfetivoLogicoByCpf = async (
    cpf: string
  ): Promise<AxiosResponse<EfetivoLogicoDto[]>> =>
    await RequestREAD.get(`${path}/GetPorCpf/${cpf}`)

  const deleteEfetivoLogicoByContrato = async (
    idEfetivoLogicoContrato: number
  ): Promise<AxiosResponse> =>
    await RequestCDU.delete(
      `EfetivoLogicoContrato/Delete?id=${idEfetivoLogicoContrato}`
    )

  const createEfetivoLogico = async (
    requestObj: EffectiveData
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/CreateEfetivoLogico`, requestObj)

  const updateEfetivoLogico = async (
    requestObj: EffectiveData
  ): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/UpdateEfetivoLogico`, requestObj)

  const atualizaStatusColaborador = async (
    requestObj: ReqUpdateStatusEffective
  ): Promise<AxiosResponse<updateEffectiveResponse>> =>
    await RequestCDU.put(`${path}/AtualizarStatusColaborador`, requestObj)

  const revalidaEfetivoLogico = async (
    idEfetivoLogico: number
  ): Promise<AxiosResponse> =>
    await RequestCDU.put(`${path}/ValidaEfetivoLogico/${idEfetivoLogico}`)

  const getExcelEfetivoLogico = async (
    excelRequest: ExcelRequestDto
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(`${path}/GetExcelEfetivoLogico`, excelRequest)

  return {
    atualizaStatusColaborador,
    createEfetivoLogico,
    deleteEfetivoLogicoByContrato,
    getEfetivoLogicoByCpf,
    getEfetivoLogicoById,
    getEfetivosporContrato,
    getExcelEfetivoLogico,
    getPesquisaContratos,
    revalidaEfetivoLogico,
    updateEfetivoLogico
  }
}

export const PesquisaEfetivoServices = () => {
  const path = 'EfetivoPesquisa'

  const getPesquisa = async (
    idUsuario: number
  ): Promise<AxiosResponse<CollapseEfetivoPesquisa[]>> =>
    await RequestREAD.get(`${path}/${idUsuario}`)

  const getPesquisaContraparte = async (
    idUsuario: number
  ): Promise<AxiosResponse<CollapseEfetivoPesquisa[]>> =>
    await RequestREAD.get(`${path}/${idUsuario}`)

  return { getPesquisa, getPesquisaContraparte }
}

export const MovimentacaoMensalServices = () => {
  const path = 'MovimentacaoMensal'

  const getMovMensalCompetenciaAtual = async (idContrato: number) =>
    await RequestREAD.get(`${path}/${idContrato}`, {})

  const createMovMensal = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestREAD.post(path, requestObj)

  const createMovMensalCDU = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(path, requestObj)

  const updateMovMensal = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.put(path, requestObj)

  const createMovAndMovEfetivo = async (
    requestObj: any
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/MovAndMovEfetivo`, requestObj)

  const getCompetenciaAnterior = async (
    idContrato: number,
    mesAno: number,
    pageSize: number,
    pageNumber: number
  ) =>
    await RequestREAD.get(
      `${path}/CompAnterior?PageNumber=${pageNumber}&PageSize=${pageSize}&idContrato=${idContrato}&mesAno=${mesAno}`
    )

  const getCompetenciaAtual = async (idContrato: number, mesAno: number) =>
    await RequestREAD.get(`${path}/CompAtual/${idContrato}/${mesAno}`)

  const getVisaoTotal = async (idContrato: number, mesAno: number) =>
    await RequestREAD.get(`${path}/GetVisaoTotalByComp/${idContrato}/${mesAno}`)

  const anexarEvidenciaMensal = async (
    objRequest: RequestAnexarEvidencia
  ): Promise<AxiosResponse> =>
    await RequestCDU.post('AnexarDocEvidenciaMovimentacao', objRequest)
  const createMovEfetivoExcel = async (
    requestObj: any
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(`${path}/MovEfetivoExcel`, requestObj)
  const deleteAnexarEvidenciaMensal = async (
    id: number
  ): Promise<AxiosResponse> =>
    await RequestCDU.delete('AnexarDocEvidenciaMovimentacao/Delete/' + id)

  return {
    anexarEvidenciaMensal,
    createMovAndMovEfetivo,
    createMovEfetivoExcel,
    createMovMensal,
    createMovMensalCDU,
    deleteAnexarEvidenciaMensal,
    getCompetenciaAnterior,
    getCompetenciaAtual,
    getMovMensalCompetenciaAtual,
    getVisaoTotal,
    updateMovMensal
  }
}

export const MovEfetivoServices = () => {
  const path = 'MovEfetivo'

  const create = async (
    requestObj: RequestMovEfetivo
  ): Promise<AxiosResponse> => await RequestCDU.post(path, requestObj)

  return { create }
}

export interface ExcelRequestDto {
  cdContrato: string
  idUsuario: number
  isContraparte?: boolean
}

export interface RequestAnexarEvidencia {
  documentoPaiId?: number
  usuarioId: number
  contratoId: number
  forncedorId: number
  tipoPendenciaId?: number
  tipoDocumentoId?: number
  nuAnoMesCompetencia?: number
  nomeArquivo: string
  descricao: string
  file: string
}
export const DownloadXlsFornecedorServices = () => {
  const path = 'DownloadXlsFornecedor'

  const getXlsFornecedor = async () => await RequestREAD.get(path)

  return { getXlsFornecedor }
}

export const MovimentacaoEfetivoServices = () => {
  const path = 'MovimentacaoEfetivo'

  const createFileXls = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/CreateFileXls`, requestObj)

  return { createFileXls }
}

export interface CollapseEfetivoPesquisa {
  idContratoUsuFornecedor: number
  contratoId: number
  usuarioId: number
  cdContrato: string
  nmEmpresaFornecedor: string
  nmUsuario: string
  dtVigenciaInicio: Date
  dtVigenciaFim: Date
  txObjetoContrato: string
  nuAnoMesCompetencia: any[]
}

export interface ResGetAllContracts {
  idContrato: number
  cdContrato: string
  nmEmpresa: string
  cdCnpj: string
  cdMatriculaContraparte?: string
  nmFornecedorPrincipal?: string
  cdCnpjPrincipal?: string
  nmContraparte?: string
  nuRamalContraparte?: string
  txObservacao: string
  objetoContrato: string
  nmFornecedor: string
  telefoneResponsavel: string
  telefoneEmpresa: string
  enderecoEmpresa: string
  dtValidacao: string | Date
  dtInicioVigencia: string | Date
  dtFimVigencia: string | Date
  qtdDiasUltimaAnalise: number
}

export interface EffectiveTableData {
  idEfetivoLogico: number
  nmColaborador: string
  cdCpf: string
  txFuncao: string
  matricula?: string
  dtNascimento: string | Date
  dtValidade: string | Date
  dtUltAtualizacao: string | Date
  statusBloqueio: string
  statusColor: string
  qtDias: number
  idEfetivoLogicoContrato: number
  flMatricula: boolean
  flMaisDeUmContrato: boolean
}

export interface ResEffectiveByContract {
  pageCount: number
  items: EffectiveTableData[]
  totalItemCount: number
  pageNumber: number
  pageSize: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  isFirstPage: boolean
  firstItemOnPage: number
  lastItemOnPage: number
}

export interface EffectiveData {
  efetivoSituacaoId?: number
  idContrato?: number
  cdCpf: string
  nmColaborador: string
  dtNascimento: string | Date
  txFuncao: string
  txFiliacaoPai: string
  txFiliacaoMae: string
  sgGenero: string
  txMatricula: string
  txNacionalidade: string
  txNaturalidade: string
  cdDocumento: string
  txEmissorDocto: string
  sgEstadoDocto: string
  cdCtps: string
  cdSerieCtps: string
  sgEstadoCtps: string
  cdPis: string
  cdCnh: string
  cdCep?: string
  txEndereco: string
  nuNumero: number
  txComplemento: string
  txBairro: string
  txCidade: string
  cdContrato?: string
  sgEstadoEnd?: string
  txLocalAcesso: string
  idEfetivoLogico?: number
  usaRefeitorio?: boolean
  flUsaRefeitorio?: boolean
  cdMatriculaContraparte?: string
  nmContraparte?: string
  nuRamal?: number
}

export interface EfetivoLogicoDto {
  efetivoSituacaoId: number
  fornecedorId: number
  cdCpf: string
  nmColaborador: string
  dtNascimento: string
  dtValidadeLogica: string
  txFuncao: string
  txFiliacaoPai: string
  txFiliacaoMae: string
  sgGenero: string
  txMatricula: string
  txNacionalidade: string
  txNaturalidade: string
  cdDocumento: string
  txEmissorDocto: string
  sgEstadoDocto: string
  cdCtps: string
  cdSerieCtps: string
  sgEstadoCtps: string
  cdPis: string
  cdCnh: string
  cdCep: string
  txEndereco: string
  nuNumero: number
  txComplemento: string
  txBairro: string
  txCidade: string
  sgEstadoEnd: string
  txLocalAcesso: string
  idEfetivoLogico: number
}

export interface ReqEffectiveByContract {
  idUsuario: number
  cdContrato: string
  pageNumber: number
  isContraparte?: boolean
  pesquisaGeral?: string
  pageSize: number
  flObterTodos?: boolean
}

export interface ReqGetAllContracts {
  idUsuario: number
  pesquisaGeral: string
  isContraparte?: boolean
}

export interface updateEffectiveResponse {
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
}

export interface ReqUpdateStatusEffective {
  idColaboradorEfetivoLogico: number
  idContrato?: number
  cdContrato?: string
  status: string
  flEnviaScarf: boolean
  flReplicarStatus?: boolean
  cdCpf?: string
}

export interface RequestMovEfetivo {
  idMovEfetivo?: number
  fornecedorId: number
  movimentacaoId: number
  nuAnoMesCompetencia: number
  cdNacionalidade: string
  cdCpfPassaporte: string
  cdGenero: string
  nmColaborador: string
  cdStatus: string
  dtAdmissao: Date
  dtDemissao: Date
  cdTipoEfetivo: string
  txFuncao: string
  cdCategoria: string
  vlHoraExtra: number
  vlSalBase: number
  flDelete: boolean
}
